import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* createSendbirdGroup({ payload: { id, onSuccess, handledErrors } }) {

  try {
    const { data } = yield call(fetch, { api: api.sendbird.group_create, data: { invited_user_uuid: id } });

    onSuccess && onSuccess(data.channel_url);
    yield put(actions.createSendbirdGroupDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createSendbirdGroupFailed,
      handledErrors,
      endpoint: api.sendbird.group_create.url
    });
  }
}

export const createSendbirdGroupSaga = takeEvery(types.CREATE_SENDBIRD_GROUP_REQUEST, createSendbirdGroup);